import React from "react";
import { Button, Modal, Text } from '@simplybenefits/sb-ui-library';

/**
 * 
 * @returns 
 */
const ReverseDentalClaimModal = ({
    open,
    onClose,
    loader,
    reversalDetails,
    reverseDentalClaim
}) => (
    <Modal
        open={open}
        onClose={onClose}
        title="Reverse Dental Claim"
        loader={loader}
        primaryButton={{
            label: "Reverse Claim",
            onClick: reverseDentalClaim
        }}
    >
        <div>
            {
                reversalDetails.payee && reversalDetails.payee.toUpperCase() === 'MEMBER' ?
                    (
                        reversalDetails.paidMember ?
                            <>
                                <Text
                                    align="left"
                                    medium
                                    display="inline-block"
                                    margin="10px 0"
                                >
                                        This claim cannot be reversed as the member has already been reimbursed.
                                </Text>

                                <Button
                                    onClick={onClose}
                                    marginTop={4}
                                    color="primary"
                                    fullWidth
                                >
                                        Close
                                </Button>
                            </>
                            :
                            <>
                                <Text
                                    align="left"
                                    medium
                                    display="inline-block"
                                    margin="10px 0"
                                >
                                        A claim reversal cannot be undone. The pending member reimbursement will be cancelled. Are you sure you want to continue?
                                </Text>
                            </>
                    )
                    :
                    <div>
                        <Text
                            align="left"
                            medium
                            display="inline-block"
                            margin="10px 0"
                        >
                            {
                                `A claim reversal cannot be undone. Are you sure you want to continue? ${ reversalDetails.paidByCheque ? 'This claim was marked as paid by cheque. This means a CDANet adjustment will not be processed for this claim and manual intervention is required. ' : '' }`
                            }
                        </Text>
                    </div>
            }
        </div>
    </Modal>
);

export default ReverseDentalClaimModal;